<template>
  <div id="editions-page">
    <b-row :style="tituloRowBG" class="tituloPaginaRow">
      <h1 class="tituloPagina text-center tituloIntro">
        {{ tituloPagina }}
      </h1>
    </b-row>
    <b-row class="p-3 p-sm-0">
      <b-col cols="12">
        <!-- Selecao periodo -->
        <div id="arvore">
          <div id="decades-row">
            <div id="decades">
              <div v-for="(decade, index) in decades" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="decade.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadYears(decade)"
                  :id="decade.id"
                  >{{ decade.title }}</b-button
                >
              </div>
            </div>
          </div>
          <div id="years-row">
            <div id="years">
              <div v-for="(year, index) in years" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="year.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadMonths(year)"
                  :id="year.id"
                  >Ano {{ year.title }}</b-button
                >
              </div>
            </div>
          </div>
          <div id="months-row">
            <div id="months">
              <div v-for="(month, index) in months" :key="index">
                <b-button
                  type="button"
                  class="periodButton"
                  :class="month.activeMenu ? 'menu-active' : ''"
                  variant="cinzaClaro"
                  @click="loadEditions(month, index)"
                  :id="month.id"
                  name="button"
                  >{{ month.title }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mt-sm-2 mb-sm-8">
        <!-- Tabela Edicoes -->
        <template v-if="editionsLoaded && !editionIsLoading">
          <template v-if="items.length">
            <div class="tipo-editions">
              <strong
                >Mês Selecionado:
                <i class="themecolor"
                  >{{ activeMonthName }} de {{ activeYearName }}</i
                ></strong
              >
            </div>
            <h4 class="text-center mt-4">Publicações</h4>
            <b-table
              striped
              hover
              :items="items"
              :fields="fields"
              :per-page="perPage"
            >
              <template v-slot:cell(number)="data">
                {{ data.item['edition_type_name'] }} &numero;
                {{ data.item['number'] }}
                {{ data.item['suplement'] | formatSuplement }}
              </template>
              <template v-slot:cell(publication_date)="data">
                {{ data.item['publication_date'] | formatDate }}
              </template>
              <template v-slot:cell(acoes)="data">
                <b-link
                  target="_blank"
                  :href="viewEdition(data.item.id)"
                  v-b-tooltip.hover
                  title="Ver Edição"
                >
                  <icon name="eye"></icon>
                </b-link>
                <b-link
                  :href="downloadEdition(data.item.id)"
                  v-b-tooltip.hover
                  title="Baixar edição"
                >
                  <icon name="download"></icon>
                </b-link>
              </template>
            </b-table>
          </template>
          <div v-else class="message">
            <strong
              >Não existem edições publicadas nesse mês, por favor selecione
              outra data.</strong
            >
          </div>
        </template>
        <template v-else-if="editionIsLoading">
          <div class="message">
            <strong>
              Carregando listagem
              <icon name="spinner" spin></icon>
            </strong>
          </div>
        </template>
        <template v-else>
          <div class="message">
            <strong
              >Selecione acima a data da edição para a exibição da
              listagem</strong
            >
          </div>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import 'moment/locale/pt-br'
  import PortalApi from '@/api/portal'
  import client from '@/main.js'

  export default {
    data() {
      return {
        client: null,
        perPage: 5,
        tituloPagina: 'Todas as edições',
        decades: [],
        years: null,
        yearsMock: [],
        months: null,
        monthsMock: [],
        currentDecade: null,
        firstDecade: null,
        firstYear: null,
        firstMonth: null,
        currentYear: null,
        currentMonth: null,
        editions: null,
        activeYear: null,
        activeYearName: null,
        activeMonthName: null,
        editionsLoaded: false,
        editionIsLoading: false,
        totalDecades: null,
        fields: [
          {
            key: 'number',
            label: 'Edição',
            sortable: false
          },
          {
            key: 'publication_date',
            label: 'Data da publicação',
            sortable: false
          },
          {
            key: 'downloads',
            label: 'Visualizações',
            sortable: false
          },
          {
            key: 'acoes',
            label: 'Ações',
            class: 'text-center'
          }
        ],
        items: []
      }
    },
    created() {
      let me = this
      me.fetchDecades()
      me.client = client.CLIENT
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    methods: {
      fetchDecades() {
        if (process.env.EDITIONS_FIRST_YEAR === undefined) {
          // console.error('EDITIONS_FIRST_YEAR não configurado no ambiente, favor configurar no .env')
          return
        }
        let me = this
        const dataIni = moment(process.env.EDITIONS_FIRST_YEAR)
        const dataEnd = moment()
        let firstYear = moment.utc(dataIni).year()
        let currentYear = dataEnd.year()
        let firstDecade = me.getDecadesFromYear(firstYear)
        me.firstDecade = firstDecade
        me.firstYear = firstYear
        me.firstMonth = moment.utc(dataIni).month() + 1
        me.currentMonth = moment().month() + 1
        me.currentYear = currentYear
        me.currentDecade = me.getDecadesFromYear(currentYear)
        me.totalDecades = parseInt((currentYear - firstDecade) / 10)
        me.createDecades()
      },
      getDecadesFromYear(year) {
        if (
          Number.isNaN(year) ||
          year.toString().length < 4 ||
          year.toString().length > 4
        ) {
          throw new Error(
            'Date must be valid and have a 4-digit year attribute'
          )
        }
        let start = parseInt(Number(year) / 10) * 10
        return start
      },
      createDecades() {
        let me = this
        for (let i = 0; i <= me.totalDecades; i++) {
          me.decades.push({
            id: i,
            decade: me.nameDecades(i),
            title: 'Anos ' + me.nameDecades(i)
          })
        }
      },
      nameDecades(ind) {
        let me = this
        return 2020 - (me.totalDecades - ind) * 10
      },
      mockYears(item) {
        let me = this

        let thisDecade = item.decade

        let firstYear = item.decade
        let endYear = item.decade + 9

        if (thisDecade === me.firstDecade) {
          firstYear = me.firstYear
        }

        if (thisDecade === me.currentDecade) {
          endYear = me.currentYear
        }

        me.yearsMock = []

        for (let i = firstYear; i <= endYear; i++) {
          me.yearsMock.push({
            id: i,
            title: i
          })
        }
      },
      loadYears(item) {
        let me = this
        me.mockYears(item)
        me.years = me.yearsMock
        me.activeYear = null
        me.activeYearName = null
        me.activeMonthName = null
        me.months = null
        me.editions = null
        me.editionsLoaded = false
        me.clearDecades()
        item.activeMenu = true
      },
      nameMonths(ind) {
        let monthName = ''
        let monthInd = ind.toString()
        switch (monthInd) {
          case '1':
            monthName = 'Janeiro'
            break
          case '2':
            monthName = 'Fevereiro'
            break
          case '3':
            monthName = 'Março'
            break
          case '4':
            monthName = 'Abril'
            break
          case '5':
            monthName = 'Maio'
            break
          case '6':
            monthName = 'Junho'
            break
          case '7':
            monthName = 'Julho'
            break
          case '8':
            monthName = 'Agosto'
            break
          case '9':
            monthName = 'Setembro'
            break
          case '10':
            monthName = 'Outubro'
            break
          case '11':
            monthName = 'Novembro'
            break
          case '12':
            monthName = 'Dezembro'
            break
          default:
            monthName = 'Erro'
        }
        return monthName
      },
      mockMonths(item) {
        let me = this
        let thisYear = item.id

        let startMonth = 1
        let endMonth = 12

        if (thisYear === me.firstYear) {
          startMonth = me.firstMonth
        }

        if (thisYear === me.currentYear) {
          endMonth = me.currentMonth
        }

        me.monthsMock = []

        for (let i = startMonth; i <= endMonth; i++) {
          me.monthsMock.push({
            id: '0' + i,
            title: me.nameMonths(i)
          })
        }
      },
      loadMonths(item) {
        let me = this
        me.editions = null
        me.editionsLoaded = false
        me.activeYear = item.id
        me.activeYearName = item.title
        me.activeMonthName = null
        me.mockMonths(item)
        me.months = me.monthsMock
        me.clearYears()
        item.activeMenu = true
      },
      clearDecades() {
        let me = this
        for (let i = 0; i < me.decades.length; i++) {
          if (me.decades[i].activeMenu === true)
            me.decades[i].activeMenu = false
        }
      },
      clearYears() {
        let me = this
        for (let i = 0; i < me.years.length; i++) {
          if (me.years[i].activeMenu === true) me.years[i].activeMenu = false
        }
      },
      clearMonths() {
        let me = this
        for (let i = 0; i < me.months.length; i++) {
          if (me.months[i].activeMenu === true) me.months[i].activeMenu = false
        }
      },
      loadEditions(item, ind) {
        let me = this
        me.editionIsLoading = true
        me.activeMonthName = item.title
        me.clearMonths()
        item.activeMenu = true
        me.items = []
        let activeMonth = parseInt(ind) + 1
        const promisse = PortalApi.fetchSelectedEditions(
          me.activeYear,
          activeMonth
        )
        promisse.then((items) => {
          me.items = items.editions
          me.perPage = me.items.length
          me.editionIsLoading = false
          me.editionsLoaded = true
        })
      },
      viewEdition(editionId) {
        return axios.defaults.baseURL + '/editions/viewPdf/' + editionId
      },
      downloadEdition(editionId) {
        return axios.defaults.baseURL + '/editions/downloadPdf/' + editionId
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment.utc(String(value)).format('LL')
        }
        return '-'
      },
      formatSuplement: function (value) {
        if (value === 1 || value === '1') {
          return ' - Suplemento'
        }
        return ''
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  #editions-page {
    h4 {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 1.2rem;
    }
    table {
      font-size: 14px;
      font-weight: 300;
      a {
        margin-right: 10px;
        color: #000;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          color: $corPrimariaClara;
        }
      }
      thead {
        th {
          border-bottom: 2px solid $corPrimaria;
          border-top: none;
        }
      }
      tbody {
        td {
          border-right: 1px solid #ddd;
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
  .tituloIntro {
    margin: auto;
  }
  #arvore {
    width: 100%;
    text-align: center;
  }
  #decades-row,
  #years-row,
  #months-row {
    width: 100%;
  }
  #decades,
  #years,
  #months {
    height: auto;
    display: flex;
    justify-content: space-between;
  }
  #decades > div,
  #years > div,
  #months > div {
    margin: 1.5rem 0.2rem;
  }
  #decades-row {
    background-color: #f0f0f0;
  }
  #years-row {
    background-color: #fafafa;
  }
  #months-row {
    background-color: #f0f0f0;
  }
  .message {
    width: 100%;
    padding: 1.5rem 0.2rem;
    border-top: dashed 1px #ccc;
    text-align: center;
    display: block;
    strong {
      font-size: 0.95rem;
      line-height: 1.3rem;
      vertical-align: middle;
    }
  }
  .tipo-editions {
    width: 100%;
    padding: 1rem 0.2rem 1rem 0;
    border-top: dashed 1px #ccc;
    border-bottom: solid 1px #dedede;
    display: block;
    * {
      font-size: 0.95rem;
      line-height: 1.3rem;
      vertical-align: middle;
    }
  }
  button.menu-active {
    background: $corPrimaria;
    color: white;
    border-radius: 3px;
    &:hover {
      background: $corPrimaria;
      color: white;
    }
  }
  /* Media Queries */
  /* xs and sm */
  @media (max-width: 767.98px) {
    #decades,
    #years {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px dashed #aaa;
    }
    #decades,
    #years,
    #months {
      height: auto;
      width: 100%;
      display: inline-block;
    }
    #decades > div,
    #years > div,
    #months > div {
      margin: 0.75rem 0rem;
    }
    .periodButton {
      width: 90%;
    }
    #editions-page {
      table {
        a {
          margin-right: 3px;
          svg {
            width: 16px !important;
            height: 16px !important;
          }
        }
      }
    }
  }
  /* Tablets */
  /* iPad */
  @media (min-width: 768px) and (max-width: 991.98px) {
    #decades > div,
    #years > div {
      margin: 1.5rem 0.2rem;
    }
    #decades > div .btn,
    #years > div .btn {
      padding: 0.375rem 0.75rem;
    }
    #months > div {
      margin: 1.5rem 0.15rem;
    }
    #months > div .btn {
      padding: 0.375rem 0.15rem;
    }
    #editions-page {
      table {
        a {
          margin-right: 4px;
          svg {
            width: 15px !important;
            height: 15px !important;
          }
        }
      }
    }
  }
  /* iPad Pro */
  @media (min-width: 992px) and (max-width: 1024.98px) {
    #months > div .btn {
      padding: 0.375rem 0.75rem;
    }
  }
  /* xs */
  @media (max-width: 355px) {
    #editions-page {
      table {
        font-size: 12px;
        th,
        td {
          padding: 0.25rem;
        }
        a {
          margin-right: 2px;
          svg {
            width: 14px !important;
            height: 14px !important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Edicoes.vue